<template>
  <div>   
      <div class="row">
        <div class="col-md-12" style="margin-top: -40px;">
            <graficodoughnut :rotulo="'DETALHES:'"
                                :legendas="legendasmeta"
                                :dados="dadosmeta"
            ></graficodoughnut>
        </div>
        <!-- <div class="col-md-12">
            <ul style="padding-left: 0px; margin-bottom: 0px; margin-top: -40px; height: 61px; overflow:auto;">
                <li v-for="(item, indice) in dadosmeta" :key="indice" class="li-item-card-dash" style="height: 15px;">
                    <span class="txt-item-card-dash-grafico">{{item.name }}</span>
                    <span class="txt-item-card-dash-grafico" style="float: right;">{{ mtdformatavalordecimal(parseFloat(item.value)) }} ({{ mtdformatavalordecimal(parseFloat(item.value) / parseFloat(item.totalgeralvendas) * 100, '') }}%)
                    </span>
                </li>
            </ul>                                            
        </div> -->
      </div>
    </div>
</template>

<script>
import { computed } from 'vue';
import util from '../../utilitarios/util';
import GraficoDoughnut from '../../components/cmpgraficodoughnut.vue';
import Skeletondashboard from '../../components/cmpskeletondashboard2.vue';
export default {
  name: "metafilial",

  components:{
    'graficodoughnut'       : GraficoDoughnut,
    'dashboard_skeleton'   : Skeletondashboard
  },

  data : function name(params) {
    return {
        legendasmeta : [],
       
        margemlucrogeral        : 0,
        showpopover             : false,
        isloading               : false,  
        vtotalservicos          : 0,
        mediafaturamento        : 0,
        usuariologado           : this.$store.state.usuario,

        dadosmeta        : []
        

    }
   
  },
  props: [
     'utodasfiliais',
     'idfilialmeta',
     'pdtini',
     'pdtfim',
     'lstfiliais',
    
  ],
  methods:{
        hidepopover(){
          setTimeout(() => {
                    this.showpopover = false;
                }, 200); 
          
        },
        mtdformatavalordecimal(valor){
				  return util.formatarvalor(valor, '');
        },
        mtdexecutadash(){
            var vself           = this;  
            vself.$emit('handlerLoader', true);   
            let filtro          = '';
            let filtrorecebimento          = '';
            if (vself.lstfiliais.length > 0) {
                let stringfilial = vself.lstfiliais.join(',');
                filtro  = ' and mr.idfilial in (' + stringfilial + ')';
            }        
            if (vself.lstfiliais.length > 0) {
                let stringfilial = vself.lstfiliais.join(',');
                filtrorecebimento  =  ' and tr.idfilial in (' + stringfilial + ')';
            }
            let parametros      = [
                {parametro: 'idclientesac', valor  : window.localStorage.getItem('idcliente')},
                {parametro: 'op',           valor  : 'metarecebimento'},
                {parametro: 'dini',         valor  : util.InverterData(vself.pdtini)},
                {parametro: 'dfim',         valor  : util.InverterData(vself.pdtfim)},
                {parametro: 'filiais',      valor : JSON.stringify(vself.lstfiliais)},
                {parametro: 'filtro', 	            valor : filtro},
                {parametro: 'filtror', 	            valor : filtrorecebimento},
            ];
            let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/dashboard.php');
            retorno.then(function (response) {
        
                vself.dadosmeta = [
                    {value: parseFloat(response.data.atingidarec), name: 'ATINGIDA'},
                    {value: parseFloat(response.data.restanterec), name: 'RESTANTE'}                       
                    
                ];
                vself.legendasmeta = util.gerardadoslegendagrafico(vself.legendasmeta);
                vself.$emit('handlerLoader', false);

            }).catch(function (response) {
                vself.$emit('handlerLoader', false);
            });
        },
  },
  mounted(){
    setTimeout(() => {
        this.mtdexecutadash();
    }, 3000);
  },
  computed:{
            
  },
}
</script>
